module.exports = __webpack_public_path__ + "assets/img/video-cba92a12.jpg";